import { render, staticRenderFns } from "./MarketSize.vue?vue&type=template&id=4a1fc743&scoped=true&lang=pug&"
import script from "./MarketSize.vue?vue&type=script&lang=js&"
export * from "./MarketSize.vue?vue&type=script&lang=js&"
import style0 from "./MarketSize.vue?vue&type=style&index=0&id=4a1fc743&scoped=true&lang=css&"
import style1 from "./MarketSize.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fc743",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VIcon,VRow,VSelect,VTextField})
